<template>
  <div class="modal-mask">
    <div class="card">
      <label class="title">Create New Banner</label>
      <label class="description"
        >Please select a file , enter a name and redirect link for the
        banner</label
      >

      <form class="form">
        <div class="form-group">
          <label class="ionput-label">Name</label>
          <input
            class="form-control"
            placeholder="Enter a name for the banner"
            v-model="name"
          />
        </div>

        <div class="form-group">
          <label class="ionput-label">Redirect Link</label>
          <input
            class="form-control"
            placeholder="Enter a redirect link"
            v-model="redirect_link"
          />
        </div>

        <div class="form-group">
          <label class="ionput-label">Image</label>
          <input
            class="form-control"
            type="file"
            @change="previewFiles"
            ref="myFiles"
          />
        </div>

        <div class="preview-container" v-if="localImgUrl">
          <label class="ionput-label">Preview (16:9 Aspect Ratio)</label>
          <img class="preview" :src="localImgUrl" alt="" />
        </div>
      </form>

      <div class="actions">
        <button
          class="btn btn-outline-primary w-100 font-weight-bold"
          @click="cancel"
        >
          Cancel
        </button>
        <button class="btn btn-primary w-100 font-weight-bold" @click="save">
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP, URLS } from "../network/http";
let NotificationsController = require("../components/NotificationsController");

export default {
  name: "DeleteItemModel",
  props: ["schemtics"],
  data() {
    return {
      name: "",
      redirect_link: "",
      files: [],
      localImgUrl: null,
    };
  },
  methods: {
    previewFiles() {
      this.files = this.$refs.myFiles.files;
      this.localImgUrl = URL.createObjectURL(this.files[0]);
    },
    save() {
      if (!this.name || this.name == "") {
        this.$toast.error("Please enter a banner name");
        return;
      }
      if (!this.files || !this.files[0]) {
        this.$toast.error("Please select an image");
        return;
      }
      NotificationsController.showActivityIndicator();
      var formData = new FormData();
      formData.append("file", this.files[0]);
      formData.append("folder", "banners");
      HTTP.post(URLS.FILES.UPLOAD, formData)
        .then((response) => {
          let img_url = response.data.url;

          let data = {
            name: this.name,
            redirect_link: this.redirect_link || "",
            img_url: img_url,
          };

          HTTP.post(URLS.BANNER.CREATE, data)
            .then((banner) => {
              this.$toast.success(banner.data.message);
              NotificationsController.hideActivityIndicator();
              this.$emit("success", response.data);
            })
            .catch((err) => {
              var msg = "";
              try {
                msg = err.response.data.message;
              } catch (error) {
                msg = err.message;
              }
              this.$toast.error(msg);
              this.$emit("fail", err.response);
              NotificationsController.hideActivityIndicator();
            });
        })
        .catch((err) => {
          var msg = "";
          try {
            msg = err.response.data.message;
          } catch (error) {
            msg = err.message;
          }
          this.$toast.error(msg);
          this.$emit("fail", err.response);
          NotificationsController.hideActivityIndicator();
        });
    },
    cancel() {
      this.$emit("cancel");
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss">
.preview-container {
  display: flex;
  flex-direction: column;

  .preview {
    width: 16rem !important;
    height: 9rem !important;
  }
}
.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;

  .card {
    width: 50%;
    max-height: 80%;
    background-color: white;
    border-radius: 4px;
    padding: 20px;

    .title {
      width: 100%;
      line-height: 50px;
      font-size: 20px;
      color: black;
    }

    .description {
      width: 100%;
      font-size: 16px;
      text-align: left;
      color: gray;
      margin-top: -20px;
      margin-bottom: 1rem;
    }

    .form {
      max-height: calc(100% - 200px);
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: scroll;
    }

    .actions {
      height: 50px;
      width: 100%;
      display: flex;
      flex-direction: row;
      margin-top: 20px;
    }
  }
}
</style>
